<template>
    <div id="footer">
        <div class="container">
            <div class="top">
                <h1 class="logo">artube</h1>
                <a href="https://artube.video/biz.html" target="_blank" class="business">비즈니스 페이지</a>
                <router-link tag="a" to="/Swap" class="business">ATT간편스왑</router-link>
                <a @click="showPolicy">개인정보처리방침</a>
                <a @click="showTerms">서비스 이용약관</a>
                <a @click="showYouth">청소년보호정책</a>
                <!-- <router-link tag="a" to="/Alliance">광고제휴문의</router-link> -->
                <a @click="showJeanGuidePopup">연재문의</a>
            </div>
            <div class="mid">
                <div class="left">
                    <p class="ps">※ 본 컨텐츠의 저작권은 저자 또는 제공처에 있으며 이를 무단 이용하는 경우 저작권법 등에 따라 법적 책임을 질 수 있습니다.</p>
                    <p class="m_ps">Artube는 블록체인과 결합한 차세대 컨텐츠 서비스 입니다.<span>아티스트와 팬, 플랫폼이 함께 성장해 나갑니다.</span></p>
                    <div class="three">
                        <p>(주)넘버스 사업자등록번호 : 773-87-00680</p>
                        <p>통신판매업신고번호 : 2019-제주이도2-0009</p>
                        <a href="https://www.ftc.go.kr/www/bizCommView.do?key=232&apv_perm_no=2019651004730200007" target="_blank">사업자 정보 확인</a>
                    </div>
                    <div class="three">
                        <p>대표이사 문영오</p>
                        <p>대표번호 02-3444-5567</p>
                        <p>이메일 contact@artube.video</p>
                    </div>
                    <p class="adress">제주도 제주시 중앙로 217, 제주벤처마루 4층 제주창조경제혁신센터 ㈜넘버스</p>
                </div>
                <div class="right">
                    <div class="categori">
                        <p class="title">카테고리</p>
                        <ul>
                            <li v-for="(item, index) in categoryList" :key="index" :class="[index % 2 == 0 ? '' : 'hidden']">
                                <router-link tag="a" :to="'/Category/' + item.idx">{{item.name}}</router-link>
                            </li>
                        </ul>
                        <ul>
                            <li v-for="(item, index) in categoryList" :key="index" :class="[index % 2 == 1 ? '' : 'hidden']">
                                <router-link tag="a" :to="'/Category/' + item.idx">{{item.name}}</router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="categori">
                        <p class="title">아트포인트</p>
                        <ul>
                            <li>
                                <router-link tag="a" to="/Charge">충전</router-link>
                            </li>
                            <!-- <li>
                                <router-link tag="a" to="Withdraw">출금</router-link>
                            </li> -->
                            <!-- <li>
                                <router-link tag="a" to="/WithdrawHistory">출금내역</router-link>
                            </li> -->
                            <li v-if="$store.state.loginCheck">
                                <router-link tag="a" to="/ChargeHistory">충전내역</router-link>
                            </li>
                            <li v-if="$store.state.loginCheck">
                                <router-link tag="a" to="UseHistory">사용내역</router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="categori">
                        <p class="title">설정</p>
                        <ul>
                            <li v-if="$store.state.loginCheck">
                                <router-link tag="a" to="/ChangeInfo">내 정보</router-link>
                            </li>
                            <li v-if="$store.state.loginCheck">
                                <router-link tag="a" to="/Mybookroom">내 서재</router-link>
                            </li>
                            <li>
                                <router-link tag="a" to="/Notice">공지사항</router-link>
                            </li>
                            <li>
                                <router-link tag="a" to="/FAQ">자주하는 질문</router-link>
                            </li>
                            <li v-if="$store.state.loginCheck">
                                <router-link tag="a" to="/Contact">1:1 문의</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <p class="copy">Copyright © 2021 artube. ALL rights reserved.</p>
                <div class="icon_box">
                    <a href="https://twitter.com/Artube_Token" target="_blank" class="twitter">twitter</a>
                    <a href="https://t.me/att_chat" target="_blank" class="message">telegram</a>
                    <a href="https://medium.com/artube" target="_blank" class="circle">medium</a>
                    <a href="https://www.youtube.com/channel/UC79E7h4jhmIaIAJpFlZ1jPA" target="_blank" class="youtube">youtube</a>
                </div>
            </div>
        </div>
        <Policy :initIsShowPopup="isShowPolicyPopup" @close="close('Policy')" />
        <Terms  :initIsShowPopup="isShowTermsPopup" @close="close('Terms')" />
        <Youth  :initIsShowPopup="isShowYouthPopup" @close="close('Youth')" />
        <Jeanguide :initIsShowPopup="isShowJeanguidePopup" @close="close('JeanGuide')" />
    </div>
</template>


<script>

import Policy from '@/components/Policy.vue'
import Terms from '@/components/Terms.vue'
import Youth from '@/components/Youth.vue'
import Jeanguide from '@/components/Jeanguide.vue'

export default {
name: 'Header',
    components: {
        Policy,
        Terms,
        Youth,
        Jeanguide,
    },
    
    data() {
        return {
            isShowPolicyPopup: false,
            isShowTermsPopup: false,
            isShowYouthPopup: false,
            isShowJeanguidePopup: false,
            
            categoryList: [],
        }
    },
    props: {
    },
    created() {
        this.getCategory();
    },
    methods: {
        showPolicy(){
            this.isShowPolicyPopup = true;
        },
        showTerms(){
            this.isShowTermsPopup = true;
        },
        showYouth(){
            this.isShowYouthPopup = true;
        },
        showJeanGuidePopup(){
            this.isShowJeanguidePopup = true;
        },
        close(popupType){
            switch(popupType){
                case 'Policy':
                    this.isShowPolicyPopup = false;
                    break;
                case 'Terms':
                    this.isShowTermsPopup = false;
                    break;
                case 'Youth':
                    this.isShowYouthPopup = false;
                    break;
                case 'JeanGuide':
                    this.isShowJeanguidePopup = false;
                    break;
            }
        },

        getCategory(){ // 카테고리 정보
            var param = 
            {
                // limit : 3
            }
            this.$Axios.post(`${this.host}/infocategory`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(res => {
                if (res.data.returnCode === 0) {
                    this.categoryList = res.data.list;
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
    }
}
</script>